import React from 'react'
import { Endpoint } from './Card'

export type AlertTone = 'err' | 'warn' | 'info'

export function AlertItem({
  tone = 'warn',
  title,
  sub,
  time,
  endpoint,
  onClick,
}: {
  tone?: AlertTone
  title: React.ReactNode
  sub?: React.ReactNode
  time?: React.ReactNode
  endpoint?: string
  onClick?: () => void
}) {
  return (
    <div
      className="row"
      style={{
        padding: '8px 12px',
        borderBottom: '1px solid var(--border)',
        alignItems: 'flex-start',
        gap: 10,
        cursor: onClick ? 'pointer' : 'default',
      }}
      onClick={onClick}
    >
      <span className={`dot ${tone}`} style={{ marginTop: 6 }} />
      <div style={{ flex: 1, minWidth: 0 }}>
        <div className="row" style={{ gap: 6 }}>
          <span style={{ fontSize: 12.5, color: 'var(--text)', fontWeight: 500 }}>{title}</span>
          {endpoint && <Endpoint>{endpoint}</Endpoint>}
        </div>
        {sub && (
          <div style={{ fontSize: 11.5, color: 'var(--text-muted)', marginTop: 2 }}>{sub}</div>
        )}
      </div>
      {time && (
        <span className="mono" style={{ fontSize: 10.5, color: 'var(--text-dim)' }}>
          {time}
        </span>
      )}
    </div>
  )
}

export function AlertChip({
  tone = 'warn',
  children,
}: { tone?: AlertTone; children: React.ReactNode }) {
  return <span className={`alert-chip ${tone}`}>{children}</span>
}
